import Service from "../../../Services/index";
import moment from "moment";

const PaymentSalary = {
    namespaced: true,
    state: {
        paymentSalaryList:[],
        paymentSalary : {
        employee_id : '',
        payment_date : '',
        net_total : '',
        week : '',
        income_salary : '',
        income_overtime_one : '',
        income_overtime_ine_haft : '',
        income_holiday : '',
        income_haft_day_work : '',
        income_benefits_bonus : '',
        income_benefits_rental_fee : '',
        income_accrued : '',
        income_commission : '',
        income_bonus_sale : '',
        income_other : '',
        total_income : '',
        cost_social_security : '',
        cost_cooperative_store : '',
        cost_rental_fee : '',
        cost_absence_from_work : '',
        cost_meal : '',
        cost_advance : '',
        cost_bank_charge : '',
        cost_damages : '',
        cost_sunday : '',
        cost_employee_card : '',
        cost_damage_security_deposit : '',
        cost_personal_income_tax : '',
        cost_room_security_deposit : '',
        cost_service : '',
        cost_phone : '',
        cost_transport_fee : '',
        cost_gas_car : '',
        cost_other : '',
        total_cost : '',
        cumulative_tax : '',
        issuer : '',
        approver : '',
        employee : '',
        cumulative_social_security : '',
        reason_income : '',
        reason_cost : '',
    },
        last_payment: "",
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },


    },
    mutations: {
        GET_PAYMENT_SALARY: (state, res) => {
            state.paymentSalaryList = res.paymentSalary.data;
            state.last_payment = res.id;
            state.dataPaginate = {
                current_page : res.paymentSalary.current_page,
                from : res.paymentSalary.form,
                last_page : res.paymentSalary.last_page,
                per_page : res.paymentSalary.per_page,
                total : res.paymentSalary.total,
                to : res.paymentSalary.to
            };
        },
        GET_PAYMENT_SALARY_BY_ID: (state, res) => {
            if(res){
                state.paymentSalary = res;
            }
        },
    },
    actions: {
        setPaymentSalary({commit},{employee_id,page=1}){
            return Service.PaymentSalary.getPaymentSalary(page,employee_id).then(data=>{
                commit("GET_PAYMENT_SALARY",data);
            })
        },
        savePaymentSalary({commit},{id,data}){
            if(!id){
                return Service.PaymentSalary.createPaymentSalary(data).then(res=>{
                    console.log("create");
                });
            }
            else{
                return Service.PaymentSalary.updatePaymentSalary(id,data).then(res=>{
                    console.log("update");
                });
            }
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        showPaymentSalaryByID({commit},id){
            return Service.PaymentSalary.showPaymentSalary(id).then(res=>{
                commit("GET_PAYMENT_SALARY_BY_ID",res);
            })
        },
        delete({ commit }, id) {
            return Service.PaymentSalary.deletePaymentSalary(id);
        },
        generatePaymentSalary({commit},data){
            return Service.PaymentSalary.generatePaymentSalary(data);
        },
        generatePaymentSalaryMonth({commit},user_id){
            return Service.PaymentSalary.generatePaymentSalaryMonth(user_id);
        },
    }
};

export default PaymentSalary;
